import { render, staticRenderFns } from "./adminRegist.vue?vue&type=template&id=8112e3ce&"
import script from "./adminRegist.vue?vue&type=script&lang=js&"
export * from "./adminRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports